<template>
	<j-card class="mb2">
		<j-accordion colorWhenClosed="bg0" :startOpen="startOpen">
			<div slot="title" class="fs4 fw7">{{ $t("product") }}</div>
			<data-list slot="body" :list="componentProps.root.list" v-on="componentHandlers" />
			<div v-if="isEditable" class="flex xs-12 xs-right p2" slot="body">
				<j-button type="primary" size="small" @click="$emit('product:update')">{{ $t("update") }}</j-button>
			</div>
		</j-accordion>
	</j-card>
</template>
<script>
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import JAccordion from "@/components/JAccordion"
import DataList from "../../DataList"

export default {
	name: "SectionProducts",
	components: {
		JCard,
		JAccordion,
		DataList,
		JButton
	},
	props: {
		componentProps: {
			type: Object
		},
		componentHandlers: {
			type: Object
		},
		startOpen: {
			type: Boolean,
			default: false
		},
		isEditable: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	methods: {}
}
</script>
